export default {
	ConnectEsign: {
		Title: 'Thiết lập chữ ký số',
		ButtonTitle: 'Kết nối ngay',
		ConnectedButtonTitle: 'Đã kết nối',
		Attention: 'Khi thiết lập ký số bằng USB Token, bạn cần lưu ý:',
		AttentionSecondLine: 'Đảm bảo đã cắm USB token vào máy tính mỗi khi thực hiện ký điện tử.'
	},
	ContactAdditionalList: {
		Title: 'Email nhận thông báo từ Cơ quan thuế',
		DeleteContactAdditionalConfirmMessage:
			'Email bị xóa sẽ không thể khôi phục lại. Bạn có chắc muốn xóa email này?',
		DeleteSuccessfully: 'Xóa email nhận thông báo từ Cơ quan thuế thành công.'
	},
	ContactAdditionalDetail: {
		Title: 'email nhận thông báo từ Cơ quan thuế',
		AddSuccessfully: 'Thêm email nhận thông báo từ Cơ quan thuế thành công.',
		UpdateSuccessfully: 'Cập nhật email nhận thông báo từ Cơ quan thuế thành công.'
	},
	AccessLog: {
		QuickSearchPlaceHolderContent: 'Tìm kiếm theo hành động, mô tả, người dùng, địa chỉ IP'
	},
	Launcher: {
		PublishInvoice: 'Phát hành hóa đơn điện tử',
		Invoice: 'Hóa đơn, PXK',
		Receipt: 'Biên lai',
		Ticket: 'Vé điện tử',
		InvoiveInput: 'Xử lý hóa đơn',
		AutomaticChecker: 'Tự động tra cứu, phân tích và kiểm tra thông tin hóa đơn.',
		ConnectAccounting:
			'Kết nối đồng bộ trực tiếp với phần mềm kế toán, giảm thiểu tối đa thao tác thủ công của kế toán.'
	},

	//Bổ sung
	AgreeBy: 'Được thỏa thuận bởi',
	PhoneNumber: 'SĐT',
	ViewHistoryConfirm: 'Xem lịch sử xác nhận',
	AcceptAgreement: 'Tôi đồng ý với thỏa thuận sử dụng phần mềm',
	AlertConfirmAgreement: 'Hãy xác nhận thỏa thuận sử dụng để sử dụng phần mềm',
	ViewAllAgreement: 'Xem đầy đủ thỏa thuận sử dụng dịch vụ',
	AlertUpdateAgreement: 'Thông báo cập nhật thỏa thuận sử dụng',
	ViewContentChange: 'Xem nội dung thay đổi',
	AcceptAgreementSuccess: 'Chấp nhận thỏa thuận sử dụng dịch vụ thành công',
	AcceptAgreementFailed:
		'Chấp nhận thỏa thuận sử dụng dịch vụ không thành công. Vui lòng liên hệ với MISA để được trợ giúp',
	SystemTitle: 'Hệ thống',
	ManageUser: 'Quản lý người dùng',
	ManageRole: 'Vai trò quyền hạn',
	ManageResource: 'Quản lý tài nguyên',
	DiaryLogs: 'Nhật ký truy cập',
	HistoryVatRate: 'Lịch sử chấp nhận thuế suất',
	Options: 'Tùy chọn',
	UserSettings: 'Thiết lập người dùng',
	WarningNoPermission: {
		Title: 'Không có quyền thực hiện thiết lập',
		Content: role =>
			`Bạn không có quyền thiết lập <span style='font-weight: 700'>${
				role ? role.toLowerCase() : ''
			}.</span> Vui lòng liên hệ người dùng có quyền Quản trị để được phân quyền.`
	},
	Roles: {
		RoleName: 'Tên vai trò',
		NumberUser: 'Số người dùng',
		CreatedDate: 'Ngày tạo',
		AlertCannotDelete: name => `Có người đang được phân quyền vai trò này.`,
		CannotDeleteRoleTitle: 'Không thể xóa vai trò',
		AlertConfirmDelete: name => `Bạn có chắc chắn muốn xóa vai trò ${name.trim()}?`,
		DeleteSuccess: 'Đã xóa vai trò thành công',
		DeleteRole: 'Xóa vai trò',
		PermissionName: 'Tên quyền',
		InvoiceInput: 'Hóa đơn đầu vào',
		InvoiceOutput: 'Hóa đơn đầu ra',
		MailBox: 'Hộp thư',
		OrgStruct: 'Cơ cấu tổ chức',
		InvoiceDetail: 'Chi tiết hóa đơn',
		DeleteAndRestore: 'Xóa và khôi phục',
		SpamDeleteAndRestore: 'Đánh dấu spam, xóa, khôi phục',
		NoteAccount: 'Đánh dấu đã hạch toán',
		Redirect: 'Điều chuyển',
		NotePaied: 'Đánh dấu đã thanh toán',
		AcceptSellerBuyer: 'Chấp nhận thông tin người mua/người bán',
		AcceptSignature: 'Chấp nhận thông tin chữ ký số',
		AcceptActiveRisk: 'Chấp nhận tình trạng hoạt động và tình trạng rủi ro của người bán',
		AlertExistRoles: 'Tên nhóm quyền đã tồn tại trên danh sách. Vui lòng kiểm tra lại.',
		AutoConnect: 'Tự động kết nối',
		Taxaxion: 'Cơ quan thuế',
		InvoiceSupplier: 'Nhà cung cấp hóa đơn',
		IgnoreCheckExistTax: 'Chấp nhận tồn tại trên Cơ quan thuế',
		HandInput: 'Nhập tay hóa đơn',
		AcceptVatRate: 'Chấp nhận thuế suất hàng hóa',
		AcceptOther: 'Chấp nhận các thông tin khác',
		AddInvoice: 'Thêm hóa đơn',
		SyncInvoice: 'Đồng bộ hóa đơn',
		AddInvoiceOutput: 'Thêm hóa đơn',
		SyncInvoiceOutput: 'Đồng bộ hóa đơn',
		SearchPlaceHolder: 'Nhập Tên vai trò để tìm kiếm'
	},
	ReportHistoryAutoLoad: 'Báo cáo lịch sử tải hóa đơn',
	ReloadData: 'Lấy lại dữ liệu'
};
